
import { mixins, Options } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import CampaignWidgetMixin from '@/mixins/campaignWidget';
import { RedemptionResult } from '../api/models/redemption';
import { IToken } from '../api/models/token';
import MToken from './MToken.vue';

@Options({
  components: {
    MToken
  }
})
export default class MRedeemableTokens extends mixins(CampaignWidgetMixin) {
  showEligibleTab = true; // If false, show Redeemed
  eligibleTokens: any[] = [];

  async created() {
    this.updateTokens();

    if (this.eligibleTokens.length === 0) {
      this.showEligibleTab = false;
    }
  }

  get getClaimText() {
    return this.innerClaimText ? this.innerClaimText : 'Claim';
  }

  get redeemedTokens(): any[] {
    return this.state.alreadyRedeemed;
  }

  get redeemedTokensByOthers(): any[] {
    return this.state.alreadyRedeemedByOthers;
  }

  get limitReached(): boolean {
    if (
      this.state.campaign?.redemptionsPerAddress &&
      this.state.alreadyRedeemed.length >= this.state.campaign.redemptionsPerAddress
    ) {
      return true;
    }
    return false;
  }

  @Watch('state.alreadyRedeemed')
  alreadyRedeemedHandler(_value: any, _oldValue: any) {
    this.updateTokens();
  }

  @Watch('state.alreadyRedeemedByOthers')
  alreadyRedeemedByOthersHandler(_value: any, _oldValue: any) {
    this.updateTokens();
  }

  updateTokens() {
    this.eligibleTokens = [];
    this.state.tokenData.forEach((token: IToken) => {
      for (let i = 0; i < token.remaining; i++) {
        this.eligibleTokens.push(token);
      }
    });
  }

  async setActiveEligibleToken(token: IToken) {
    if (!this.limitReached) {
      this.$store.commit(`${this.mmid}/setActiveEligibleToken`, token, { root: true });
    }
  }

  async setActiveRedemption(token: RedemptionResult) {
    this.$store.commit(`${this.mmid}/setActiveRedemption`, token, { root: true });
  }
}
